export default __webpack_public_path__ + "static/media/nhlFantasyPWRS.dad0ab76.png";